import _objectSpread from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/objectSpread";
import _objectWithoutProperties from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/objectWithoutProperties"; //@ts-check

import React from 'react';
import { withStyles, createStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import MaterialLink from '@material-ui/core/Link';
import Icon from '../core/Icon';
import AppsUtils from '../apps/utils';
import getHost from '../utils/host';
import store from '../store';

var styles = function styles() {
  return createStyles({
    textIcon: {
      display: 'inline-block',
      fontSize: '1rem',
      width: '1.5em',
      textAlign: 'left',
      top: 1.3,
      verticalAlign: 'text-bottom'
    },
    icon: {
      fontSize: '1rem'
    }
  });
};
/**
 * A versatile icon that makes sure icons are consistent throughout the app
 * @param {import('./types').LinkFormatterProps & import('@material-ui/core/styles').WithStyles<typeof styles, true> & React.HTMLAttributes<any>} props
 */


var Link = function Link(_ref) {
  var classes = _ref.classes,
      theme = _ref.theme,
      text = _ref.text,
      value = _ref.value,
      icon = _ref.icon,
      app = _ref.app,
      openInNewTab = _ref.openInNewTab,
      noWrap = _ref.noWrap,
      color = _ref.color,
      variant = _ref.variant,
      rest = _objectWithoutProperties(_ref, ["classes", "theme", "text", "value", "icon", "app", "openInNewTab", "noWrap", "color", "variant"]);

  var iconEl = null;
  /** @type any */

  var iconProps = {
    className: text ? classes.textIcon : classes.icon
  };

  if (typeof icon === 'string') {
    iconProps.type = icon;
    iconEl = React.createElement(Icon, iconProps);
  } else if (React.isValidElement(icon)) {
    iconEl = icon;
  } else if (typeof icon === 'object') {
    iconProps = _objectSpread({}, iconProps, icon);
    iconEl = React.createElement(Icon, iconProps);
  }

  var children = React.createElement(React.Fragment, null, iconEl, text);
  /** @type {Partial<import('./types').LinkFormatterProps>} */
  // @ts-ignore

  var defaultProps = theme.getProps('Formatter.Link');
  /** @type {import('@material-ui/core/Link').LinkProps} */

  var compProps = _objectSpread({
    display: 'inline'
  }, defaultProps, rest, {
    href: value,
    children: children,
    color: color
  });

  if (app && value) {
    compProps.href = AppsUtils.redirect(app, value); // @ts-ignore

    compProps.component = 'a';
  }

  if (openInNewTab) compProps.target = '_blank';
  return React.createElement(Typography, {
    component: "div",
    display: "inline",
    noWrap: noWrap,
    color: color,
    variant: variant
  }, React.createElement(MaterialLink, compProps));
};

Link.defaultProps = {
  openInNewTab: false,
  noWrap: false,
  text: null,
  app: null
};
var LinkFormatter = withStyles(styles, {
  withTheme: true,
  name: 'ECLinkFormatter'
})(Link);
export default LinkFormatter;